import instance from "../../api";
import {kpiApiBase} from "./cutover";

export const getHuntersReports = filters => {
  return instance(true)
    .post(`/crm/kpi/hunters_report/`, filters)
    .then(res => {
      return res?.data;
    });
};
export const getPlans = filters => {
  return instance(true)
    .get(`/crm/kpi/sd_plans/`, {params: filters})
    .then(res => {
      return res?.data;
    });
};
export const getHunterDetails = (id, params) => {
  if (isNaN(id)) return;
  const base = kpiApiBase(params?.year, params?.month);
  return instance(true)
    .post(`${base}/hunters_report/${id}/`, params)
    .then(res => {
      return res?.data;
    });
};

// KPI v2 (TZ раздел 5) — типы/грейды хантеров, отчёт РОПов, уведомления.
export const getHunterTypes = () => {
  return instance(true)
    .get(`/crm/kpi/hunter_types/`)
    .then(res => {
      return res?.data;
    });
};

export const getHunterGrade = hunterId => {
  return instance(true)
    .get(`/crm/kpi/hunters/${hunterId}/grade/`)
    .then(res => {
      return res?.data;
    });
};

export const postHunterGrade = (hunterId, kpi_hunter_type_id) => {
  return instance(true)
    .post(`/crm/kpi/hunters/${hunterId}/grade/`, {kpi_hunter_type_id})
    .then(res => {
      return res?.data;
    });
};

export const getRopReport = filters => {
  return instance(true)
    .post(`/crm/kpi/rop_report/`, filters)
    .then(res => {
      return res?.data;
    });
};

export const getRopInfo = () => {
  return instance(true)
    .get(`/crm/kpi/rop_info/`)
    .then(res => {
      return res?.data;
    });
};

export const getKpiNotifications = params => {
  return instance(true)
    .get(`/crm/kpi/notifications/`, {params})
    .then(res => {
      return res?.data;
    });
};

export const markKpiNotificationRead = kpiNotificationId => {
  return instance(true)
    .post(`/crm/kpi/notifications/${kpiNotificationId}/read/`)
    .then(res => {
      return res?.data;
    });
};

export const markAllKpiNotificationsRead = () => {
  return instance(true)
    .post(`/crm/kpi/notifications/read_all/`)
    .then(res => {
      return res?.data;
    });
};
